/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentSync {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentSync.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentSync>): WellArchitectedFrameworkAssessmentSync {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentSync(), model);
        WellArchitectedFrameworkAssessmentSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentSync>): WellArchitectedFrameworkAssessmentSync {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentSync.newInstance(<WellArchitectedFrameworkAssessmentSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentSync) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentSync): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.AWS) {
            models.WellArchitectedFrameworkAssessmentAwsSyncFields.fixupPrototype(this.AWS);
        }
    }

    AWS: models.WellArchitectedFrameworkAssessmentAwsSyncFields;

}
